export const KEYS_CODES = {
	ENTER: 13,
};
